
// document.addEventListener("DOMContentLoaded", function () {

//   const buttons = document.querySelectorAll('.target-btn');
//   const groups = document.querySelectorAll('.target-group');

//   buttons.forEach(button => {
//     button.addEventListener('click', function () {

//       // active button
//       buttons.forEach(btn => btn.classList.remove('active'));
//       this.classList.add('active');

//       const target = this.dataset.target;

//       // switch groups
//       groups.forEach(group => {
//         if (group.dataset.group === target) {
//           group.style.display = 'grid';
//         } else {
//           group.style.display = 'none';
//         }
//       });

//     });
//   });

// });




// document.addEventListener("DOMContentLoaded", function () {

//   const buttons = document.querySelectorAll('.target-btn');
//   const groups = document.querySelectorAll('.target-group');
//   const titles = document.querySelectorAll('.group-title');

//   buttons.forEach(button => {
//     button.addEventListener('click', function () {

//       const target = this.dataset.target;

//       // Toggle active button
//       buttons.forEach(btn => btn.classList.remove('active'));
//       this.classList.add('active');

//       // Switch product groups
//       groups.forEach(group => {
//         group.style.display = (group.dataset.group === target) ? 'grid' : 'none';
//       });

//       // Switch titles
//       titles.forEach(title => {
//         title.style.display = (title.dataset.title === target) ? 'inline' : 'none';
//       });

//     });
//   });

// });

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll('.target-btn').forEach(button => {

//     button.addEventListener('click', function () {
//       document.body.classList.add('page-loading');
//     });

//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  // Fix 2026-10-08: the "return to the 1X bundle you came from" memory used to hijack
  // EVERY later 1X click in the tab (e.g. 2X on SKIP, then 1X on SIP -> SKIP Starter Set).
  // Now we remember which 2X page the click went to, and only reuse the saved 1X page
  // when the shopper clicks 1X on that same 2X page. Everywhere else 1X follows its own link.
  const handleOf = (u) => { try { const m = new URL(u, window.location.origin).pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; } catch (err) { return null; } };

  // When going FROM 1X bundle TO 2X product
  document.querySelectorAll('.target-btn-2x').forEach(button => {
    button.addEventListener('click', function () {
      const currentProduct = this.dataset.currentProduct;
      const destination = this.getAttribute('href');
      if (currentProduct && destination && !this.classList.contains('active') && handleOf(currentProduct) !== handleOf(destination)) {
        sessionStorage.setItem('last_1x_product', JSON.stringify({ from: currentProduct, to: destination }));
      } else {
        sessionStorage.removeItem('last_1x_product');
      }
      document.body.classList.add('page-loading');
    });
  });

  // When on 2X product and clicking back to 1X
  document.querySelectorAll('.target-btn-1x').forEach(button => {
    button.addEventListener('click', function (e) {
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem('last_1x_product')); } catch (err) { saved = null; }
      sessionStorage.removeItem('last_1x_product');
      const here = handleOf(window.location.href);
      if (saved && saved.from && saved.to && handleOf(saved.to) === here && handleOf(saved.from) !== here) {
        e.preventDefault();
        document.body.classList.add('page-loading');
        window.location.href = saved.from;
      }
      // otherwise: normal link to this product's own 1X page
    });
  });

});